import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import InventarioItemsGrid from './InventarioItemsGrid.jsx';
import InventarioItemsAbm from './InventarioItemsAbm.jsx';

/**
 * VEC-3312 — Catálogo de Ítems del módulo de Inventario y Control de Stock v3.0.
 *
 * Módulo NUEVO, aislado del inventario legacy (Pañol2 -> Items, /repuestos): permisos
 * propios (INVENTARIO_ITEMS_*), flag propio (inventarioItems.habilitado) y endpoints propios
 * (/inventario/items). No comparte componentes con components/repuestos ni components/panol2.
 */
const InventarioItems = ({ match }) => {
  return (
    <div className="content-wrapper">
      <div className="content-header row">
        <div className="content-header-left col-md-6 col-12 mb-2">
          <h3 className="content-header-title">
            <FormattedMessage
              id="inventarioItems.header_catalogo_de_items"
              defaultMessage="Catálogo de Ítems"
            />
          </h3>
        </div>
      </div>
      <div className="content-body">
        <Switch>
          <Route exact path={`${match.url}`} render={(props) => <InventarioItemsGrid {...props} />} />
          <Route exact path={`${match.url}/add`} render={(props) => <InventarioItemsAbm {...props} action="ADD" />} />
          <Route exact path={`${match.url}/:id`} render={(props) => <InventarioItemsAbm {...props} action="VIEW" />} />
          <Route exact path={`${match.url}/:id/edit`} render={(props) => <InventarioItemsAbm {...props} action="EDIT" />} />
        </Switch>
      </div>
    </div>
  );
};

export default withRouter(InventarioItems);
